// extracted by mini-css-extract-plugin
export default {"main_container":"UserAddNewFile_main_container__BUqWO","title":"UserAddNewFile_title__Z6dKw","title_sm":"UserAddNewFile_title_sm__YxFYD"};